/* eslint-disable no-var */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cIf from 'classnames';
import _, { noop } from 'lodash';

var tr = require('ts-translate-js').default.boundTR;
var trN = tr;
var modal = require('../modal');
var up = require('react-addons-update');
var _utilctl = require('../utilctl');
import createClass from 'create-react-class';

import PasswordReset from '../authentication/passwordreset';
import UserFirstLastNames from './userfirstlastnames';
import UserPhoneNumbers from './userphonenumbers';
import UserEmails from './useremails';
import UserAddress from './useraddress';
import { EMPTY_UUID } from '../../src/logic';


export const EditionPanel = createClass({
    displayName: "EditionPanel",

    propTypes: {
        isEdition: PropTypes.bool,
        profile: PropTypes.shape({
            EmailAddress: PropTypes.string,
            EmailValidation: PropTypes.string,
            Password: PropTypes.string,
            PasswordValidation: PropTypes.string,
            FirstName: PropTypes.string,
            LastName: PropTypes.string,
            IsMale: PropTypes.bool,
            PhoneDay: PropTypes.string,
            PhoneEvening: PropTypes.string,
            MainAddress: PropTypes.shape({
                Address1: PropTypes.string,
                Address2: PropTypes.string,
                City: PropTypes.string,
                Province: PropTypes.string,
                PostalCode: PropTypes.string,
                Country: PropTypes.string
            })
        }),
        profileEditionError: PropTypes.shape({
            AccountAlreadyExists: PropTypes.bool,
            MissingFields: PropTypes.bool,
            InvalidDayPhoneFormat: PropTypes.bool,
            InvalidEmailFormat: PropTypes.bool,
            InvalidEveningPhoneFormat: PropTypes.bool,
            InvalidPassword: PropTypes.bool
        }),
        onProfileChange: PropTypes.func,
        onCompleteEdition: PropTypes.func,
        onValidationIncorrect: PropTypes.func,
        onCancelEdition: PropTypes.func,
        onFailedEditionOK: PropTypes.func,
        clearError: PropTypes.func,
        profileEditionInProgress: PropTypes.bool,
        isWhiteLabel: PropTypes.bool,
        showForgetPasswordForm: PropTypes.bool,
        showSuccessSendResetEmail: PropTypes.bool
    },

    getInitialState() {
        return ({ validPassword: null });
    },

    componentDidMount() {
        this.raiseContentChanged();
    },

    componentDidUpdate() {
        this.raiseContentChanged();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function () {
            if (this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    isEmpty(val) {
        return (val == "");
    },

    profileEditionErrorMessage() {
        var message = ""

        if (this.props.profile.FirstName == "" || this.props.profile.LastName == "" || this.props.profile.EmailAddress == "" || (this.props.profile.Password == "" && !this.props.isEdition) || this.props.profile.PhoneEvening == ""
            || this.props.profile.MainAddress.Address1 == "" || this.props.profile.MainAddress.City == "" || this.props.profile.MainAddress.Province == "" || this.props.profile.MainAddress.PostalCode == "" || this.props.profile.MainAddress.Country == "")
            message = tr("profileedition.requiredfieldmissing")
        else if (this.props.profileEditionError != null) {
            if (this.props.profileEditionError.MissingFields)
                message = tr("profileedition.requiredfieldmissing")
            else if (this.props.profileEditionError.InvalidDayPhoneFormat || this.props.profileEditionError.InvalidEmailFormat || this.props.profileEditionError.InvalidEveningPhoneFormat || this.props.profileEditionError.InvalidPostalCodeFormat || this.props.profileEditionError.InvalidPassword)
                message = tr("profileedition.fieldformatinvalid")
            else if (this.props.profileEditionError.AccountAlreadyExists)
                message = tr("profileedition.accountalreadyexists")
        }
        else
            message = tr("profileedition.errorhasoccured")

        return (
            <div className="form-group">
                <div className="alert alert-danger text-center" role="alert" style={{margin:"0"}}>{message}</div>
                <p className="help-block"><a href="#" onClick={() => this.handleOnForgetPassword()}>{tr("login.forgotpassword")}</a></p>
            </div>
        )
    },

    validateProfile() {
        if ((!this.props.isEdition && this.props.profile.EmailAddress == "")
            || (this.props.profile.Password != "" && this.props.profile.Password != this.props.profile.PasswordValidation))
            return false
        else
            return true
    },

    handleOnChange(name, isAddress, e) {
        this.props.onProfileChange(
            up(this.props.profile, isAddress
                ? { MainAddress: { [name]: { $set: e.target.value } } }
                : { [name]: { $set: e.target.value } }));
    },

    handleOnNamesChange(names) {
        var fMap = {firstName: 'FirstName', lastName: 'LastName'};
        var change = _.mapKeys(names, (_, name) => fMap[name]);

        this.props.onProfileChange(_.assign({}, this.props.profile, change));
    },

    handleOnPhoneNumbersChange(phoneNumber) {
        var fMap = {homePhone: 'PhoneEvening', PhoneDay: 'PhoneDay'};
        var change = _.mapKeys(phoneNumber, (_, name) => fMap[name]);

        this.props.onProfileChange(_.assign({}, this.props.profile, change));
    },

    handleOnEmailsChange(emails) {
        var fMap = {email: 'EmailAddress', emailValidation: 'EmailValidation'};
        var change = _.mapKeys(emails, (_, name) => fMap[name]);
        this.props.onProfileChange(_.assign({}, this.props.profile, change));
    },

    handleOnAddressChange(mainAddress) {
        this.props.onProfileChange(_.merge({}, this.props.profile, { MainAddress: mainAddress }));
    },

    handleOnCompleteEdition(e) {
        e.stopPropagation();
        e.preventDefault();

        if (this.validateProfile()) {
            this.props.onCompleteEdition()
        } else {
            this.props.onValidationIncorrect()
        }
    },

    handleOnCancelEdition() {
        this.props.onCancelEdition()
    },

    handleOnFailedEditionOK() {
        this.props.onFailedEditionOK()
    },

    handleOnForgetPassword() {
        this.setState({ showForgetPasswordForm: true });
    },

    handleOnCancelResetPassword() {
        this.clearError();
        this.setState({ showForgetPasswordForm: false });
    },

    handleOnConfirmResetPassword() {
        this.clearError();
        this.setState({ showForgetPasswordForm: false });
        this.props.onCancelEdition();
    },

    clearError() {
        if(this.props.clearError)
            this.props.clearError()
    },

    createPhoneDayErrorMessage() {
        var phoneDayErrorMessage = (this.props.profileEditionError != null && this.props.profileEditionError.InvalidDayPhoneFormat)
            ? <span id="helpBlock" className="help-block">{tr("profileedition.phoneformat")}</span>
            : null;
        return phoneDayErrorMessage;
    },

    createPhoneEveningErrorMessage() {
        var phoneEveningErrorMessage = (this.props.profileEditionError != null && this.props.profileEditionError.InvalidEveningPhoneFormat)
            ? <span id="helpBlock" className="help-block">{tr("profileedition.phoneformat")}</span>
            : null;
        return phoneEveningErrorMessage;
    },

    createPostalCodeErrorMessage() {
        var postalCodeErrorMessage = (this.props.profileEditionError != null && this.props.profileEditionError.InvalidPostalCodeFormat)
            ? <span id="helpBlock" className="help-block">{tr("profileedition.postalcodeformat")}</span>
            : null;
        return postalCodeErrorMessage;
    },

    createPasswordErrorMessage() {
        var passwordErrorMessage = (this.props.profileEditionError != null && this.props.profileEditionError.InvalidPassword)
            ? <span id="helpBlock" className="help-block">{tr("profileedition.passwordformat")}</span>
            : null;
        return passwordErrorMessage;
    },

    createPasswordValidationErrorMessage() {
        var passwordValidationErrorMessage = (this.props.profile.Password != this.props.profile.PasswordValidation)
            ? <span id="helpBlock" className="help-block">{tr("profileedition.passwordvalidationerror")}</span>
            : null;
        return passwordValidationErrorMessage;
    },

    createEmailErrorMessage() {
        if (this.props.profileEditionError != null && this.props.profileEditionError.InvalidEmailFormat) {
            return <span id="helpBlock" className="help-block">{tr("profileedition.emailformat")}</span>
        } 
        return null;
    },

    prepareUserEmailsComponent(emailErrorMessage) {
        if (!this.props.isEdition) {
            return <UserEmails
                        email={this.props.profile.EmailAddress}
                        emailValidation={this.props.profile.EmailValidation}
                        emailErrorMessage={emailErrorMessage}
                        showProfileEditionError={this.props.showProfileEditionError}
                        handleOnEmailsChange={(email, emailValidation) => this.handleOnEmailsChange(email, emailValidation)} />
        }
        return null
    },

    preparePageTitle() {
        var titleAccount = (this.props.isWhiteLabel ? "" : " - " + tr("Reservatech.net"));
        return (this.props.isEdition
            ? tr("profileedition.title.edition") + titleAccount
            : tr("profileedition.title.create") + titleAccount);
    },

    prepareDefaultPasswordValue() {
        return this.props.isEdition ? "*********" : ""
    },

    prepareEditButtonSection() {
        var editButtonsSection = null
        if (this.props.profileEditionInProgress) {
            editButtonsSection = <_utilctl.PleaseWaitSpinner size="md" />;
        } else {
           editButtonsSection = 
                <div className="btn-toolbar pull-right">
                    <button type="button" id="btnCancel" className="btn btn-default" onClick={this.handleOnCancelEdition}>{tr("profileedition.cancel")}</button>
                    <button type="submit" id="btnConfirm" className="btn btn-primary">{tr("profileedition.confirm")}</button>
                </div>
        }
        return editButtonsSection;
    },

    render() {
        var errorMessage = null;
        var phoneDayErrorMessage = null;
        var phoneEveningErrorMessage = null;
        var postalCodeErrorMessage = null;
        var passwordErrorMessage = null;
        var passwordValidationErrorMessage = null;
        var emailErrorMessage = null;
        
        if(this.props.showProfileEditionError) {
            errorMessage = this.profileEditionErrorMessage();
            phoneDayErrorMessage = this.createPhoneDayErrorMessage();
            phoneEveningErrorMessage = this.createPhoneEveningErrorMessage();
            postalCodeErrorMessage = this.createPostalCodeErrorMessage();
            passwordErrorMessage = this.createPasswordErrorMessage();
            passwordValidationErrorMessage = this.createPasswordValidationErrorMessage();
            emailErrorMessage = this.createEmailErrorMessage();
        }
        
        var title = this.preparePageTitle()
        var defaultPasswordValue = this.prepareDefaultPasswordValue()
        var editButtonsSection = this.prepareEditButtonSection()
        var userEmails = this.prepareUserEmailsComponent(emailErrorMessage);
        
        if (this.state.showForgetPasswordForm == true) {
            return (
                <PasswordReset
                    onChangeEmailPassword={this.handleOnChangeEmailPassword}
                    onConfirmResetPassword={this.handleOnConfirmResetPassword}
                    onCancelResetPassword={this.handleOnCancelResetPassword}
                    email={this.props.profile.EmailAddress} />
            );
        }

        return (
            <form onSubmit={this.handleOnCompleteEdition}>
                <h3 className={cIf([{"text-center": this.props.integ !== "rese"}])}>{title}</h3>
                <br />
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <h4>{tr("profileedition.personal")}</h4>
                        <hr />
                        <UserFirstLastNames
                            firstName={this.props.profile.FirstName}
                            lastName={this.props.profile.LastName}
                            handleOnNamesChange={(names) => this.handleOnNamesChange(names)}
                            showProfileEditionError={this.props.showProfileEditionError}
                            displayRequiredMessage={false} />
                        <div className={cIf({ "has-error": this.props.profile.Sex == "" && this.props.showProfileEditionError, "form-group": true })}>
                            <label className="control-label">{tr("profileinfo.sex")}</label>
                            <div className="radio"><label><input type="radio" defaultChecked={this.props.isEdition && this.props.profile.IsMale} name="inputSex" value="true" onClick={this.handleOnChange.bind(this, "IsMale", false)} />{tr("profileinfo.male")}</label></div>
                            <div className="radio"><label><input type="radio" defaultChecked={this.props.isEdition && !this.props.profile.IsMale} name="inputSex" value="false" onClick={this.handleOnChange.bind(this, "IsMale", false)} />{tr("profileinfo.female")}</label></div>
                        </div>

                        {userEmails}

                        <div className={cIf({ "has-error": ((this.props.profile.Password == "" && !this.props.isEdition) || passwordErrorMessage != null) && this.props.showProfileEditionError, "form-group": true })}>
                            <label htmlFor="inputPassword" className="control-label">{tr("profileinfo.password")}</label>
                            <input type="password" id="inputPassword" placeholder={defaultPasswordValue} className="form-control" maxLength={30} onChange={this.handleOnChange.bind(this, "Password", false)}></input>
                            {passwordErrorMessage}
                        </div>
                        <div className={cIf({ "has-error": passwordValidationErrorMessage != null && this.props.showProfileEditionError, "form-group": true })}>
                            <label htmlFor="inputPasswordValidation" className="control-label">{tr("profileedition.passwordvalidation")}</label>
                            <input type="password" id="inputPasswordValidation" placeholder={defaultPasswordValue} maxLength={30} className="form-control" onChange={this.handleOnChange.bind(this, "PasswordValidation", false)}></input>
                            {passwordValidationErrorMessage}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <h4>{tr("profileedition.contact")}</h4>
                        <hr />
                        <UserPhoneNumbers
                            phoneEvening={this.props.profile.PhoneEvening}
                            phoneDay={this.props.profile.PhoneDay}
                            showProfileEditionError={this.props.showProfileEditionError}
                            showBothPhoneNumbers={true}
                            phoneEveningErrorMessage={phoneEveningErrorMessage}
                            phoneDayErrorMessage={phoneDayErrorMessage}
                            handleOnPhoneNumbersChange={(phoneNumber) => this.handleOnPhoneNumbersChange(phoneNumber)} />
                        <UserAddress
                            MainAddress={this.props.profile.MainAddress}
                            showProfileEditionError={this.props.showProfileEditionError}
                            showWholeAddress={true}
                            postalCodeErrorMessage={postalCodeErrorMessage}
                            handleOnAddressChange={(mainAddress) => this.handleOnAddressChange(mainAddress)} />
                    </div>
                </div>
                {errorMessage}
                {editButtonsSection}
            </form>
        );
    }
});

export const ShippingAddressPanel = createClass({
    displayName: "ShippingAddressPanel",

    propTypes: {
        onCloseShippingAddress: PropTypes.func,
        onRefreshData: PropTypes.func,
        shippingaddresses: PropTypes.arrayOf(
            PropTypes.shape({
                Address: PropTypes.string,
                Address2: PropTypes.string,
                City: PropTypes.string,
                Province: PropTypes.string,
                PostalCode: PropTypes.string,
                Country: PropTypes.string
            })
        )
    },

    getInitialState() {
        return ({ showEditShippingAddressPanel: false });
    },

    componentDidMount() {
        this.errorModalContainerRef = React.createRef();
    },

    componentWillUnmount() {
        if (this.removeShippingAddressRequest != null) this.removeShippingAddressRequest.abort();
        if (this.updateShippingAddressRequest != null) this.updateShippingAddressRequest.abort();
    },

    refreshData() {
        this.props.onRefreshData();
    },

    handleOnClose() {
        this.props.onCloseShippingAddress();
    },

    handleOnRemove(addressID) {
        this.handleOnRemoveConfirm(addressID);
    },

    handleOnRemoveConfirm(addressID) {
        this.props.onRemoveShippingAddress(addressID);
    },

    handleOnRemoveErrorShippingOK() {
        // TOCHECK
        //this.props.onRemoveErrorShippingOK();

        this.setState({ showRemoveShippingError: false });
    },
    
    handleOnAddNewAddress() {
        this.setState({ showEditShippingAddressPanel: true, shippingAddressToModify: { ID: EMPTY_UUID } });
    },

    handleOnEditShippingAddress(address) {
        this.setState({ showEditShippingAddressPanel: true, shippingAddressToModify: address });
    },

    handleOnModifyShippingAddress(shippingAddressToModify) {
        this.setState({ shippingAddressToModify, showEditShippingError: false });
    },

    handleOnRemoveShippingAddress(id) {
        this.removeShippingAddressRequest = tsapp.mvcapi.postCtl("profile/RemoveShippingAddress", { id })
            .success(function (data) {
                this.refreshData();
            }.bind(this))
            .notSuccess(function (data) {
                this.setState({ showRemoveShippingError: true })
                this.setState({ errorOnAction: (data.message == "PROFILE_IS_EMPTY") ? data.message : "" });
            }.bind(this));
    },

    handleOnConfirmEditShippingAddress() {
        this.updateShippingAddressRequest = tsapp.mvcapi.postCtl("profile/UpdateShippingAddress", { address: this.state.shippingAddressToModify })
            .success(function (data) {
                this.setState({ showEditShippingAddressPanel: false });
                this.setState({ shippingAddressToModify: null });
                this.refreshData();
            }.bind(this))
            .notSuccess(function (data) {
                this.setState({
                    showEditShippingError: true,
                    shippingAddressErrorResult: data,
                    errorOnAction: (data.message == "PROFILE_IS_EMPTY") ? data.message : ""
                });
            }.bind(this));
    },

    handleOnCancelEditShippingAddress() {
        this.setState({ showEditShippingAddressPanel: false, shippingAddressToModify: null });
    },

    render() {
        var shippingAddressePanel = this.props.shippingaddresses.map(function (address) {
            return (
                <div key={address.ID} className="panel-body">
                    <div className="well">
                        <div className="row">
                            <div className="col-sm-12">
                                <h4 className="text-bold">{address.Description}</h4>
                                <div className="btn-toolbar">
                                    <button className="btn btn-default" type="button" onClick={this.handleOnRemoveShippingAddress.bind(this, address.ID)}>
                                        <span className="glyphicon glyphicon-trash"></span> {tr("shippingaddresspanel.remove")}
                                    </button>
                                    <button className="btn btn-primary" type="button" onClick={this.handleOnEditShippingAddress.bind(this, address)}>
                                        <span className="glyphicon glyphicon-pencil"></span> {tr("shippingaddresspanel.edit")}
                                    </button>
                                </div>

                                <address>
                                    {address.Name}<br />
                                    {address.Address1}<br />
                                    {address.Address2}<br />
                                    {address.City}<br />
                                    {address.Province + ", " + address.Country}<br />
                                    {address.PostalCode}<br />
                                </address>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }.bind(this))

        var errorMessage = this.state.showRemoveShippingError
                         ? <modal.ConfirmOK showCloseButton={false} title={tr("shippingaddresspanel.failedremove")}
                                            messagehtml={tr("shippingaddresspanel.removeerror")}
                                            onOK={this.handleOnRemoveErrorShippingOK}
                                            onClose={noop}
                                            container={this.props.errorModalContainer} />
                         : null

        //Si on est en mode edit
        var shippingPanel = this.state.showEditShippingAddressPanel
                          ? <EditShippingAddressPanel shippingAddress={this.state.shippingAddressToModify}
                                                      onModifyShippingAddress={this.handleOnModifyShippingAddress}
                                                      onConfirmEditShippingAddress={this.handleOnConfirmEditShippingAddress}
                                                      onCancelEditShippingAddress={this.handleOnCancelEditShippingAddress}
                                                      onFailedEditShippingOK={this.handleOnFailedEditShippingOK}
                                                      shippingAddressErrorResult={this.state.shippingAddressErrorResult}
                                                      showEditShippingError={this.state.showEditShippingError} />
                          : <form>
                              {errorMessage}
                              <h3 className="text-center">{tr("shippingaddresspanel.allshippingaddresses")}</h3>
                              {shippingAddressePanel}
                              <div className="row">
                                  <div className="col-xs-12">
                                      <div className="btn-toolbar pull-right">
                                          <button className="btn btn-default" type="button" onClick={this.handleOnClose}>
                                              {tr("shippingaddresspanel.close")}
                                          </button>
                                          <button className="btn btn-primary" type="button" onClick={this.handleOnAddNewAddress}>
                                              <span className="glyphicon glyphicon-plus"></span> {tr("shippingaddresspanel.addnew")}
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </form>

                          return (
                                    <modal.EmptyBox style={{width:"auto"}} onClose={noop} showCloseButton={false} container={this.props.container}>
                                        {shippingPanel}
                                    </modal.EmptyBox>
                          );
    }
});

export const EditShippingAddressPanel = createClass({
    displayName: "EditShippingAddressPanel",

    propTypes: {
        onModifyShippingAddress: PropTypes.func,
        onCancelEditShippingAddress: PropTypes.func,
        onConfirmEditShippingAddress: PropTypes.func,
        onFailedEditShippingOK: PropTypes.func,
        shippingAddressErrorResult: PropTypes.shape({
            MissingFields: PropTypes.bool,
            InvalidPostalCodeFormat: PropTypes.bool
        }),
        shippingAddress: PropTypes.shape({
            Address: PropTypes.string,
            Address2: PropTypes.string,
            City: PropTypes.string,
            Province: PropTypes.string,
            PostalCode: PropTypes.string,
            Country: PropTypes.string
        })
    },

    isEmpty(val) {
        return (val == null || val == "")
    },

    handleOnChange(name, e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { [name]: { $set: e.target.value } }))
    },

    handleOnCancel() {
        this.props.onCancelEditShippingAddress()
    },

    handleOnConfirm(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.onConfirmEditShippingAddress();
    },

    handleOnFailedEditShippingOK() {
        this.props.onFailedEditShippingOK()
    },

    shippingAddressEditError() {
        var message = ""

        if (this.props.shippingAddressErrorResult.MissingFields)
            message = tr("shippingaddresspanel.requiredfieldmissing")
        else if (this.props.shippingAddressErrorResult.InvalidPostalCodeFormat)
            message = tr("shippingaddresspanel.invalidpostalcodeformat")
        else
            message = tr("shippingaddresspanel.errorhasoccured")

        return (<div className="form-group">
            <div className="alert alert-danger text-center" role="alert">{message}</div>
        </div>)
    },

    render() {

        if (this.props.shippingAddress === null)
            return (<div>{tr("shippingaddresspanel.loading")}</div>)

        var errorMessage = this.props.showEditShippingError && this.props.shippingAddressErrorResult != null
            ? this.shippingAddressEditError()
            : null

        return (
            <div className="container-fluid">
                <form onSubmit={this.handleOnConfirm}>
                    <h3 className="text-center">{tr("shippingaddresspanel.editShippingAddress")}</h3>
                    <div className="form-horizontal">
                        <div className="form-group">
                            <label htmlFor="inputDescription" className="control-label">{tr("profileinfo.description")}</label>
                            <input type="text" id="inputDescription" className="form-control" value={this.props.shippingAddress.Description} onChange={this.handleOnChange.bind(this, "Description")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputName" className="control-label">{tr("profileinfo.name")}</label>
                            <input type="text" id="inputName" className="form-control" value={this.props.shippingAddress.Name} onChange={this.handleOnChange.bind(this, "Name")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputAddress1" className="control-label">{tr("profileinfo.address")}</label>
                            <input type="text" id="inputAddress1" className="form-control" value={this.props.shippingAddress.Address1} onChange={this.handleOnChange.bind(this, "Address1")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputAddress2" className="control-label">{tr("profileinfo.address2")}</label><span> <em>{tr("profileedition.optional")}</em></span>
                            <input type="text" id="inputAddress2" className="form-control" value={this.props.shippingAddress.Address2} onChange={this.handleOnChange.bind(this, "Address2")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputCity" className="control-label">{tr("profileinfo.city")}</label>
                            <input type="text" id="inputCity" className="form-control" value={this.props.shippingAddress.City} onChange={this.handleOnChange.bind(this, "City")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputProvince" className="control-label">{tr("profileinfo.province")}</label>
                            <input type="text" id="inputProvince" className="form-control" value={this.props.shippingAddress.Province} onChange={this.handleOnChange.bind(this, "Province")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputPostalCode" className="control-label">{tr("profileinfo.postalcode")}</label>
                            <input type="text" id="inputPostalCode" className="form-control" value={this.props.shippingAddress.PostalCode} onChange={this.handleOnChange.bind(this, "PostalCode")}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputCountry" className="control-label">{tr("profileinfo.country")}</label>
                            <input type="text" id="inputCountry" className="form-control" value={this.props.shippingAddress.Country} onChange={this.handleOnChange.bind(this, "Country")}></input>
                        </div>
                        {errorMessage}
                        <div className="form-group">
                            <div className="btn-toolbar pull-right">
                                <button className="btn btn-default" type="button" onClick={this.handleOnCancel}>{tr("shippingaddresspanel.cancel")}</button>
                                <button className="btn btn-primary" type="submit">{tr("shippingaddresspanel.confirm")}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
});
